import { render, staticRenderFns } from "./givePoint.vue?vue&type=template&id=378ffbf8&scoped=true&"
import script from "./givePoint.vue?vue&type=script&lang=js&"
export * from "./givePoint.vue?vue&type=script&lang=js&"
import style0 from "./givePoint.vue?vue&type=style&index=0&id=378ffbf8&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "378ffbf8",
  null
  
)

export default component.exports